import { RewardBalance } from "@factory/model/query-model-reward";
import { useDateTimeContext } from "@shared/utility/date-time-service/date-time.context";
import classNames from "classnames";
import { LegacyRef } from "react";
import Barcode from "react-barcode";
import QRCode from "react-qr-code";

import { appAsset } from "../../../app.asset";

interface PrintableCardProps {
  displayMode: string;
  balanceData?: RewardBalance;
  cardRef?: LegacyRef<HTMLDivElement> | undefined;
}

export function PrintableCard({
  displayMode,
  balanceData,
  cardRef,
}: PrintableCardProps) {
  const { formatDate } = useDateTimeContext();
  return (
    <div
      id="PrintableCard"
      className={`flex customer-card bg-white shadow-md w-[17rem] h-[32em] rounded-lg p-5`}
      ref={cardRef}
    >
      <div
        className={classNames(
          `flex flex-1 flex-col justify-center items-center`
        )}
      >
        <img
          src={appAsset.logo}
          alt="tenant-logo"
          className="min-h-36 min-w-32 mx-4"
        />
        <div className="flex flex-1 flex-col items-center justify-center bg-white px-4 my-2">
          {displayMode === "qr" && (
            <QRCode value={balanceData?.card_alias || ""} size={190} />
          )}
          {displayMode === "barcode" && (
            <Barcode value={balanceData?.card_alias || ""} width={1.5} />
          )}
        </div>
        <div
          className={classNames(
            "flex flex-1 flex-col items-center w-full justify-between space-y-14"
          )}
        >
          <h1>
            {balanceData?.first_name} {balanceData?.last_name}
          </h1>
          <p className="text-xs font-semibold">
            Card Expiration: {formatDate(balanceData?.expiration_date)}
          </p>
        </div>
      </div>
    </div>
  );
}
export default PrintableCard;
